/**
 * NL类库
 *
 * @module nllib
 */

/**
 * 获取指定node以下（包括自己）的所有子node的列表
 *
 * @class nllib/src/tree-helper/get_child_node_list
 * @static
 *
 * @param {object} pParameter
 *
 * @param {object} pParameter.node 结点实体，通过property_name_for_children包含树状数据
 * @param {string} pParameter.property_name_for_children children的属性名称
 *
 * @return {array} 一维数组，指定node以下（包括自己）的所有子node的列表
 *
 * @demo src/tree-helper/get_child_node_list/demo/get_child_node_list.demo.js
 */

// const extend = require(`extend`);
// const Q = require(`q`);
const _ = require(`underscore`);
// const moment = require(`moment`);

const get_child_node_list = function ({node, property_name_for_children = `children`}) {
    const list = [];
    let stack = [
        node,
    ];
    while (stack.length > 0) {
        const current_stack = stack.shift();
        list.push(current_stack);

        const children = current_stack[property_name_for_children];
        if (!_.isArray(children)) continue;
        if (children.length <= 0) continue;

        stack = stack.concat(children);
    }
    return list;
};

module.exports = get_child_node_list;
